import * as React from "react";

import { Icon } from "@material-ui/core";
import { TaskRecurrency } from "Models/Tasks/TaskRecurrencies/TaskRecurrency";
import i18n from "Translations/i18n";
import styles from "./TaskRecurrencyBlock.scss";

interface IProps {
    taskRecurency: TaskRecurrency;
}

const TaskRecurrencyBlock: React.FunctionComponent<IProps> = (props: IProps) => (
    <div className={styles.taskRecurrencyBlock}>
        <div className={styles.recurrencyType}>
            <Icon className={styles.typeIcon}>loop</Icon>
            <div className={styles.typeName}>{i18n.t(`tasks.taskRecurrency.${props.taskRecurency.type}`)}</div>
        </div>
    </div>
);

export default TaskRecurrencyBlock;


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateBlockOverview/TaskTemplateBlockView/TaskTemplateBlockCard/TaskRecurrencyBlock/TaskRecurrencyBlock.tsx